import { put } from '../base';

export async function setOrder(payload: { ids: string[]; shopName: string }): Promise<void> {
  const { ids, shopName } = payload;
  return put(`v4/shops/byName/${shopName}/collections`, { json: { collectionsIds: ids } }).then(() => {});
}
